import { QueryFactory } from '@lmt/shared-types';

const tenantAdministratorRoleName = 'TenantAdministrator';

export function useRoles() {
  return QueryFactory.RoleQuery.useGetRolesQuery().data ?? [];
}

export function useTenantAdministratorRoleId() {
  const roles = useRoles();
  return roles.find((x) => x.name === tenantAdministratorRoleName)?.id;
}
